import { render, staticRenderFns } from "./FeaturedAlbumItem.vue?vue&type=template&id=1d289148&scoped=true&"
import script from "./FeaturedAlbumItem.vue?vue&type=script&lang=js&"
export * from "./FeaturedAlbumItem.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedAlbumItem.vue?vue&type=style&index=0&id=1d289148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d289148",
  null
  
)

export default component.exports